(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Account bottom sheet handler
  (function() {
    function initAccountSheet() {
      var trigger = document.querySelector('[data-account-sheet-trigger]');
      var overlay = document.querySelector('[data-account-sheet-overlay]');
      var sheet = document.querySelector('[data-account-sheet]');
      var dropdown = document.querySelector('.header__account-dropdown');
      
      if (!trigger || !overlay || !sheet) return;
      
      function isMobileOrTablet() {
        return window.innerWidth < 1024;
      }
      
      function moveSheetToPortal() {
        var portal = document.getElementById('account-sheet-portal');
        if (isMobileOrTablet() && portal && sheet.parentElement && sheet.parentElement.classList && sheet.parentElement.classList.contains('header__account-dropdown')) {
          portal.appendChild(sheet);
        }
      }
      
      function moveSheetToDropdown() {
        var portal = document.getElementById('account-sheet-portal');
        if (!isMobileOrTablet() && portal && portal.contains(sheet) && dropdown) {
          dropdown.insertBefore(sheet, dropdown.querySelector('button').nextSibling);
        }
      }
      
      var scrollLockScrollY = 0;
      var scrollbarWidth = 0;
      function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      }
      function openSheet() {
        if (isMobileOrTablet()) {
          scrollbarWidth = getScrollbarWidth();
          moveSheetToPortal();
          overlay.classList.add('open');
          scrollLockScrollY = window.scrollY || window.pageYOffset;
          if (scrollbarWidth > 0) {
            document.documentElement.style.setProperty('--account-sheet-scrollbar-width', scrollbarWidth + 'px');
            document.documentElement.style.paddingRight = scrollbarWidth + 'px';
            document.body.style.paddingRight = scrollbarWidth + 'px';
          }
          document.body.style.position = 'fixed';
          document.body.style.top = '-' + scrollLockScrollY + 'px';
          document.body.style.left = '0';
          document.body.style.right = '0';
        } else {
          moveSheetToDropdown();
        }
        sheet.classList.add('open');
        trigger.classList.add('open');
        document.body.classList.add('account-sheet-open');
      }
      
      function closeSheet() {
        if (isMobileOrTablet()) overlay.classList.remove('open');
        sheet.classList.remove('open');
        trigger.classList.remove('open');
        document.body.classList.remove('account-sheet-open');
        if (isMobileOrTablet()) {
          document.body.style.position = '';
          document.body.style.top = '';
          document.body.style.left = '';
          document.body.style.right = '';
          if (scrollbarWidth > 0) {
            document.documentElement.style.removeProperty('--account-sheet-scrollbar-width');
            document.documentElement.style.paddingRight = '';
            document.body.style.paddingRight = '';
          }
          window.scrollTo(0, scrollLockScrollY);
          var portal = document.getElementById('account-sheet-portal');
          if (portal && portal.contains(sheet) && dropdown) {
            dropdown.insertBefore(sheet, dropdown.querySelector('button').nextSibling);
          }
        }
      }
      
      function handleOutsideClick(e) {
        if (!sheet.classList.contains('open')) return;
        if (sheet.contains(e.target)) return;
        if (trigger && trigger.contains(e.target)) return;
        closeSheet();
      }
      
      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        if (sheet.classList.contains('open')) {
          closeSheet();
        } else {
          openSheet();
        }
      });
      overlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeSheet();
      });
      var dragHandle = sheet.querySelector('[data-account-sheet-close]');
      if (dragHandle) {
        dragHandle.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          if (isMobileOrTablet() && sheet.classList.contains('open')) closeSheet();
        });
        dragHandle.addEventListener('keydown', function(e) {
          if ((e.key === 'Enter' || e.key === ' ') && isMobileOrTablet() && sheet.classList.contains('open')) {
            e.preventDefault();
            closeSheet();
          }
        });
      }
      document.addEventListener('click', handleOutsideClick);
      if (isMobileOrTablet()) moveSheetToPortal();
      window.addEventListener('resize', function() {
        var wasOpen = sheet.classList.contains('open');
        if (isMobileOrTablet()) {
          moveSheetToPortal();
          if (wasOpen) {
            overlay.classList.add('open');
            scrollLockScrollY = window.scrollY || window.pageYOffset;
            document.body.style.position = 'fixed';
            document.body.style.top = '-' + scrollLockScrollY + 'px';
            document.body.style.left = '0';
            document.body.style.right = '0';
          }
        } else {
          moveSheetToDropdown();
          if (wasOpen) {
            overlay.classList.remove('open');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            window.scrollTo(0, scrollLockScrollY);
          }
        }
      });
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccountSheet);
    } else {
      initAccountSheet();
    }
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
